import { render, staticRenderFns } from "./LichSuVanTaiKhachForm.vue?vue&type=template&id=1315c25c"
import script from "./LichSuVanTaiKhachForm.vue?vue&type=script&lang=js"
export * from "./LichSuVanTaiKhachForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports